export enum _size {
  L = "L-56",
  M = "M-44",
  S = "S-32",
  XS = "XS-24",
  unset = "unset",
}

export enum _style {
  primary = "primary",
  primaryWhite = "primary-white",
  secondary = "secondary",
  secondary2 = "secondary-origin",
  outline = "outline",
  flat = "flat",
  clear = "clear",
  clear2 = "clear-origin",
  primary_clear = "prim-clear",
  link = "link",
  linkDefault = "default",
  neutral = "neutral",
}

export enum _nightMode {
  off = "day",
  on = "night",
}

export enum _theme {
  light = "light",
  dark = "dark",
  system = "system",
}

export enum _clear {
  off = "off",
  on = "on",
}

export enum _typeBtn {
  default = "default",
  dropdown = "dropdown",
  defaultIcon = "default-icon",
  icon = "icon",
  iconCircle = "circly",
  split = "split",
  loader = "loader",
}

export enum _stateInput {
  normal = "normal",
  active = "active",
  readonly = "",
}

export enum _typeInput {
  text = "text",
  email = "email",
  phone = "phone",
  number = "number",
  counter = "counter",
  date = "date",
  textarea = "textarea",
}

export enum _sizeText {
  xlb = "xl-bold",
  xl = "xl",
  lbold = "lbold",
  l = "l",
  mbold = "mbold",
  m = "m",
  sbold = "sbold",
  sbold_fix = "sbold-fix",
  s = "s",
  s_fix = "s-fix",
  xs = "xs",
  xs_fix = "xs-fix",
  xsbold = "xsbold",
  p2med = "work-p-2-med-14",
  hmpmed = "p-3-bold",
  hmp2 = "hm-p2",
}

export enum _aligeText {
  left = "left",
  right = "right",
  center = "center",
}

export enum _colorText {
  default = "default",
  black = "black",
  positive = "positive",
  negative = "negative",
  neutral = "neutral",
}

export enum _sizeHeading {
  h1 = "heading1",
  h2 = "heading2",
  h2_2 = "heading2_2",
  h3 = "heading3",
  h4 = "heading4",
  h5 = "heading5",
  h6 = "heading6",
}

export enum _status {
  success = "success",
  error = "error",
  info = "info",
  warning = "warning",
  neutral = "neutral",
}

export enum _typePreview {
  main = "main",
}

export enum _typeLogo {
  default = "default",
  white = "white",
  secondary = "secondary",
}

export enum _typeLabel {
  primary = "primary",
  secondary = "secondary",
  outline = "outline",
  flat = "flat",
  input = "input",
}

const version = 28;
const api = "/";
const url_telegram =
  "https://t.me/hm_vvlab_bot/?start=restart_user_4f771026-5a9f-4764-9fae-4b0d63d08878";
const url_whatsapp =
  "https://api.whatsapp.com/send/?phone=79853445619&text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5&app_absent=0`";
const url_android_app = "https://work.vvlab.space/static/apps/work.apk";
const url_telegram_ispolnitel = "https://t.me/vvlabspace";
const url_telegram_kanal = "https://t.me/workvvlabspace/37179";

export {
  api,
  url_android_app,
  url_telegram,
  url_telegram_ispolnitel,
  url_telegram_kanal,
  url_whatsapp,
  version,
};
